import Login from './login/Login';

const Components = {
   
  Login
}

export default Components;
